import createIcon from '../../createIcon';

/**
 * @component @name FileDownloadDone
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAuMTMwMSA1LjQxTDE4LjcyMDEgNEw5LjUzMDEyIDEzLjE5TDUuMjgwMTIgOC45NUwzLjg3MDEyIDEwLjM2TDkuNTMwMTIgMTYuMDJMMjAuMTMwMSA1LjQxWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTE5LjAwMDEgMThINS4wMDAxMlYyMEgxOS4wMDAxVjE4WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const FileDownloadDone = createIcon('FileDownloadDone', [
  [
    'path',
    {
      d: 'M20.1301 5.41L18.7201 4L9.53012 13.19L5.28012 8.95L3.87012 10.36L9.53012 16.02L20.1301 5.41Z',
      key: '5quth4',
    },
  ],
  ['path', { d: 'M19.0001 18H5.00012V20H19.0001V18Z', key: '27q849' }],
]);

export default FileDownloadDone;
